import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createSlots as _createSlots, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d1f75df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-table-" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  key: 1,
  class: "d-flex justify-space-between align-center mt-8 border-t pt-3"
}
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Resultados por página", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 2,
  class: "text-right"
}

import { withDefaults, ref, watch, onMounted, computed } from 'vue';
import * as XLSX from 'xlsx';
import { IHeadersTable, IOptionsSelect } from '@/types';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import { VueGoodTable } from 'vue-good-table-next';
import { Authentication, Preloader } from '@/store';
import { useRoute } from 'vue-router';
import { format } from 'date-fns';
import { MoleculeFilters, MoleculePagination } from '@/components/molecules';
import { AtomButton, DownloadIcon } from '@/components/atoms';
import { AtomBadge, AtomTooltip, AtomInput, AtomInputMoney, AtomSelect, LoaderIcon } from '../atoms';

interface IProps {
  headers: Array<IHeadersTable>;
  items: any[];
  filters?: boolean;
  enableOptions?: boolean;
  disableSelectInfo?: boolean;
  selectOnCheckboxOnly?: boolean;
  textEmpty?: string;
  selectedClass?: string;
  indexSelect?: number;
  perPage?: number;
  page?: number;
  totalItems?: number;
  update?: boolean;
  pagination?: boolean;
  loading?: boolean;
  itemSelect?: any;
  hasOptions?: boolean;
  isFinanceira?: boolean;
  exportHeaders?: Array<IHeadersTable>;
  // checkbox?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTable',
  props: {
    headers: null,
    items: null,
    filters: { type: Boolean, default: false },
    enableOptions: { type: Boolean },
    disableSelectInfo: { type: Boolean },
    selectOnCheckboxOnly: { type: Boolean },
    textEmpty: { default: 'Sem informações para exibição' },
    selectedClass: { default: '' },
    indexSelect: null,
    perPage: { default: 10 },
    page: { default: 1 },
    totalItems: { default: 0 },
    update: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    loading: { type: Boolean },
    itemSelect: null,
    hasOptions: { type: Boolean, default: true },
    isFinanceira: { type: Boolean },
    exportHeaders: null
  },
  emits: [
  'handleUpload',
  'rowClick',
  'changePerPage',
  'changePage',
  'updateRow',
  'searching',
  'handleSort',
  'blur',
],
  setup(__props: any, { emit }) {

const props = __props as { headers: Array<IHeadersTable>, items: any[], filters: boolean, enableOptions?: boolean, disableSelectInfo?: boolean, selectOnCheckboxOnly?: boolean, textEmpty: string, selectedClass: string, indexSelect?: number, perPage: number, page: number, totalItems: number, update: boolean, pagination: boolean, loading?: boolean, itemSelect?: any, hasOptions: boolean, isFinanceira?: boolean, exportHeaders?: Array<IHeadersTable> };



const route = useRoute();
const dataAtual = ref<any>(new Date());
const dataFormatada = format(dataAtual.value, 'dd-MM-yyyy');
const title = computed(() => {
  let mk = Authentication.getters.getUser.value.roles?.find((f) => f.name.toLowerCase() == 'mk');
  return route.meta[String(mk?.data.role).toLowerCase()] ?? '';
});

const table = ref(null);
const lengthItems = computed(() => {
  return Math.ceil(props.totalItems / perPageTable.value);
});
const search = ref<string>('');


const updateValues = ref<any>({});
const page = ref(1);
const perPageTable = ref(10);
// let badges = props.headers.filter((f) => f.type == 'badge');

let pagination = {
  enabled: true,
  mode: 'records',
  perPage: perPageTable.value,
};

const computedItems = computed(() => {
  return props.items.filter((x) => (x.archived ? x.archived === 0 : true));
});

const exportHandler = () => {
  // assuming headers and exportHeaders are available here, for example:
  const headers = props.headers;
  const exportHeaders = props.exportHeaders ?? [];
  console.log(headers)
  console.log(exportHeaders)


  // Merge headers and exportHeaders into a single array.
  const combinedHeaders = [...headers, ...exportHeaders];
  console.log(combinedHeaders)

  const getPropertyByPath = (object, path) => {
    return path.split('.').reduce((o, i) => o[i], object);
  };

  // map computedItems to a new array with keys replaced by the corresponding labels from combinedHeaders
  const itemsToExport = computedItems.value.map(item => {
    const newItem = {};

    combinedHeaders.forEach(header => {
      const originalValue = getPropertyByPath(item, header.field);
      if (originalValue !== undefined) {
        newItem[header.label] = originalValue;
      }
    });

    Object.keys(item).forEach(key => {
      console.log(key)
      const header = combinedHeaders.find(h => h.field === key);
      console.log(header)
      if (header && header.label) {
        if (header.formatFn) {
          newItem[header.label] = header.formatFn(item[key])
        } else {
          newItem[header.label] = item[key];
        }
      }
    });
    return newItem;
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(itemsToExport);

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const xlsxBytes = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  const blob = new Blob([xlsxBytes], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = `${title.value} ${dataFormatada}.xlsx`;
  a.href = url;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

onMounted(() => {
  page.value = props.page;
  perPageTable.value = props.perPage;

  if (props.itemSelect) {
    props.headers
      .filter((f) => !!f.update)
      .map((x) => {
        updateValues.value[String(x.update)] = props.itemSelect[String(x.update)];
      });
  }
});
watch(
  () => page.value,
  () => {
    emit('changePage', page.value);
  }
);
watch(
  () => props.page,
  () => {
    page.value = props.page;
  }
);
watch(
  () => perPageTable.value,
  () => {
    emit('changePerPage', perPageTable.value);
  }
);
watch(
  () => props.perPage,
  () => {
    perPageTable.value = props.perPage;
  }
);
watch(
  () => updateValues.value,
  () => {
    emit('updateRow', updateValues.value);
  },
  { deep: true }
);

watch(
  () => search.value,
  () => {
    emit('searching', search.value);
  }
);

function onSortChange(params) {
  emit('handleSort', {
    type: params[0].type,
    field: params[0].field,
  });
}

watch(
  () => props.itemSelect,
  () => {
    if (props.itemSelect) {
      updateValues.value = {};

      const data: any = {};

      props.headers
        .filter((f) => !!f.update)
        .map((x) => {
          data[String(x.update)] = props.itemSelect[String(x.update)];
        });
      updateValues.value = data;
    }
  }
);

function handleBlur(event) {
  emit('blur', event);
}

function rowStyleClassFn(row) {
  let clss = ` ${row.archived != undefined ? (row.archived == 1 ? 'inactive' : 'active') : ''} row-table ${
    props.selectedClass
  } ${props.indexSelect && row.id == props.indexSelect ? 'selected-row-sp' : ''} ${
    props.indexSelect && row.id == props.indexSelect && props.isFinanceira ? 'background-orange' : ''
  }`;

  return clss;
}

function validLine(row) {
  return props.indexSelect && row.id == props.indexSelect;
}
function handleUpload() {
  emit('handleUpload');
}
function onRowClick(params) {
  emit('rowClick', params);
}
function selectionChanged(params) {
  console.log('selected row', params);
}

return (_ctx: any,_cache: any) => {
  const _component_VSelect = _resolveComponent("VSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.filters)
      ? (_openBlock(), _createBlock(_unref(MoleculeFilters), {
          key: 0,
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          "has-search": "",
          onHandleUpload: handleUpload,
          onHandleBlur: handleBlur,
          "has-options": props.hasOptions
        }, {
          areaFilter: _withCtx(() => [
            _renderSlot(_ctx.$slots, "areaFilter"),
            (
          _unref(computedItems).length > 0 &&
          !(_unref(route).fullPath.includes('applicationsWithMostLicences') ||
            _unref(route).fullPath.includes('headquartersWithMostLicences') ||
            _unref(route).fullPath.includes('collaboratorsWithMostLicencesObtained') ||
            _unref(route).fullPath.includes('collaboratorsLicenceUtilization') ||
            _unref(route).fullPath.includes('groupsLicenceUtilization') ||
            _unref(route).fullPath.includes('mostUsedManufacturerApplications') ||
            _unref(route).fullPath.includes('licencesExpirationDateByCompany') ||
            _unref(route).fullPath.includes('licenceFirstLicencing'))
        )
              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                  key: 0,
                  prependIcon: "",
                  appendIcon: "",
                  background: "white",
                  outlined: "",
                  text: "Exportar",
                  style: {"margin-left":"10px"},
                  onClick: _withModifiers(exportHandler, ["prevent"])
                }, {
                  prependIcon: _withCtx(() => [
                    _createVNode(_unref(DownloadIcon))
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["modelValue", "has-options"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueGoodTable), {
      isLoading: props.loading,
      ref_key: "table",
      ref: table,
      onSortChange: onSortChange,
      "select-options": {
      enabled: __props.enableOptions,
      selectOnCheckboxOnly: __props.selectOnCheckboxOnly,
      disableSelectInfo: __props.disableSelectInfo,
    },
      onOnSelectedRowsChange: selectionChanged,
      styleClass: "vgt-table",
      "row-style-class": rowStyleClassFn,
      onRowClick: onRowClick,
      columns: __props.headers,
      rows: _unref(computedItems)
    }, _createSlots({
      loadingContent: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), { class: "ma-auto w-100" }))
      ]),
      "table-row": _withCtx((props) => [
        _createElementVNode("div", _hoisted_1, [
          (props.column.type == 'badge')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                (__props.update && !!props.column.mode && validLine(props.row))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (props.column.mode == 'money')
                        ? (_openBlock(), _createBlock(_unref(AtomInputMoney), {
                            key: 0,
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (props.column.mode == 'date')
                        ? (_openBlock(), _createBlock(_unref(AtomInput), {
                            key: 1,
                            type: "date",
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (props.column.mode == 'input')
                        ? (_openBlock(), _createBlock(_unref(AtomInput), {
                            key: 2,
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (props.column.mode == 'select')
                        ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                            key: 3,
                            width: "154px",
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                            options: props.column.options
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_unref(AtomBadge), {
                      key: 1,
                      text: props.formattedRow[props.column.field],
                      color: props.row.color,
                      "bg-color": props.row.bgColor
                    }, null, 8, ["text", "color", "bg-color"]))
              ]))
            : _createCommentVNode("", true),
          (props.column.type == 'hint')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createVNode(_unref(AtomTooltip), {
                  text: props.row[props.column.field]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.formattedRow[props.column.field]), 1)
                  ]),
                  _: 2
                }, 1032, ["text"])
              ]))
            : (props.column.field == 'actions')
              ? _renderSlot(_ctx.$slots, "actions", _mergeProps({ key: 2 }, _ctx.$attrs, { props: props }))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  (__props.update && !!props.column.mode && validLine(props.row))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (props.column.mode == 'money')
                          ? (_openBlock(), _createBlock(_unref(AtomInputMoney), {
                              key: 0,
                              label: props.column.label,
                              prependIcon: "",
                              modelValue: updateValues.value[props.column.update],
                              "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                            }, {
                              prependIcon: _withCtx(() => [
                                _createTextVNode(" R$ ")
                              ]),
                              _: 2
                            }, 1032, ["label", "modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true),
                        (props.column.mode == 'date')
                          ? (_openBlock(), _createBlock(_unref(AtomInput), {
                              key: 1,
                              type: "date",
                              modelValue: updateValues.value[props.column.update],
                              "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                              label: props.column.label
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                          : _createCommentVNode("", true),
                        (props.column.mode == 'input')
                          ? (_openBlock(), _createBlock(_unref(AtomInput), {
                              key: 2,
                              modelValue: updateValues.value[props.column.update],
                              "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                              label: props.column.label
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                          : _createCommentVNode("", true),
                        (props.column.mode == 'select')
                          ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                              key: 3,
                              width: "154px",
                              label: props.column.label,
                              modelValue: updateValues.value[props.column.update],
                              "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                              options: props.column.options
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "options"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ])),
          (props.column.extra)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(props.column.classExtra)
              }, _toDisplayString(props.row[props.column.fieldExtra]), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (!!__props.textEmpty)
        ? {
            name: "emptystate",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(__props.textEmpty), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["isLoading", "select-options", "columns", "rows"]),
    (props.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_VSelect, {
              modelValue: perPageTable.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((perPageTable).value = $event)),
              class: "d-flex align-center ms-6",
              items: [10, 15, 20],
              variant: "solo",
              density: "compact"
            }, null, 8, ["modelValue"])
          ]),
          (props.totalItems != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_unref(MoleculePagination), {
                  class: "pagination-component",
                  modelValue: page.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((page).value = $event)),
                  numberOfPages: _unref(lengthItems)
                }, null, 8, ["modelValue", "numberOfPages"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.pagination)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Mostrando " + _toDisplayString(_unref(computedItems).length > 0 ? 1 + perPageTable.value * (page.value - 1) : 0) + " a " + _toDisplayString(_unref(computedItems).length + (page.value - 1) * perPageTable.value) + " de " + _toDisplayString(props.totalItems) + " itens ", 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})